export const sponsorInitialState = {
    sponsor: null,
    isLoading: true,
}